
/**
 * Debug class
 * controlls the debugging information
 */
class Debug {
    
    public warnings: boolean = true;
    public logs: boolean = true;
    public errors: boolean = true;

    constructor() {
        const isDev = this.isDevelopment();
        this.warnings = isDev;
        this.logs = isDev;
        this.errors = isDev;
    }

    /**
     * warn debugging function
     * @param callback Function
     * @returns {void}
     */
    warn = (callback: Function) => {
        if(!this.warnings) return;
        callback();
    }
    /**
     * log debugging function
     * @param callback Function
     * @returns {void}
     */
    log = (callback: Function) => {
        if(!this.logs) return;
        callback();
    }
    /**
     * error debugging function
     * @param callback Function
     * @returns {void}
     */
    error = (callback: Function) => {
        if(!this.errors) return;
        callback();
    }
    /**
     * determines if the app mode is development
     * otherwise is production
     * @returns boolean
     */
    isDevelopment = () : boolean => {
        return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
    }

}


// export Debug class instance (singleton)
export const __debug = new Debug();